import { render, staticRenderFns } from "./billIndex.vue?vue&type=template&id=005b3fd3&scoped=true"
import script from "./billIndex.vue?vue&type=script&lang=js"
export * from "./billIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b3fd3",
  null
  
)

export default component.exports